import { render, staticRenderFns } from "./CostSupplier.vue?vue&type=template&id=2135a2ce&"
import script from "./CostSupplier.vue?vue&type=script&lang=js&"
export * from "./CostSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports